import React, { useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import axios from "axios";

// ----------------------------------------------------------------------
export default function AvatarImgFromUrl({ image, variant, sx, ...props }) {
  const [imageObj, setimageObj] = useState(null);
  useEffect(() => {
    return () => {
      setimageObj(null);
    };
  }, []);
  useEffect(() => {
    if (!image) return;
    const init = async () => {
      try {
        const response = await axios.get(`${image}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const imageDataUrl = URL.createObjectURL(blob);
        setimageObj(imageDataUrl);
      } catch (error) {
        console.error(error);
      }
    };
    init();
  }, [image]);
  if (!imageObj) return <></>;
  return (
    <>
      <Avatar src={imageObj} variant={variant ? variant : "rounded"} sx={sx} />
    </>
  );
}
